import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "7942c493-e629-47ad-8216-40568f46757e",
  publicId: "14",
  name: "Monopole, Dipole and Quadrupoles",
  difficulty: 2,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, task01],
};

export default lesson;
